import {Injectable} from '@angular/core';
import {LoadingController} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  loading: HTMLIonLoadingElement;
  private isLoading = false;

  constructor(public loadingController: LoadingController) {
  }

  async startLoading(message = 'Caricamento...', duration = 4000) {
    this.isLoading = true;
    await this.loadingController.create({
      duration,
      message
    }).then(a => {
      a.present().then(() => {
        if (!this.isLoading) {
          a.dismiss().then(() => this.isLoading = false);
        }
      });
    });
  }

  async stopLoading() {
    if (!this.isLoading) {
      return;
    }
    this.isLoading = false;
    try {
      setTimeout(async () => {
        await this.loadingController.dismiss();
      }, 100);
    } catch (e) {
      console.log(e);
    }

  }
}
